import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';
import { accounts } from './accounts';
import { ai } from './ai';
import { budget } from './budget';
import { categories } from './categories';
import { common } from './common';
import { creditCards } from './creditCards';
import { financings } from './financings';
import { goals } from './goals';
import { home } from './home';
import { installments } from './installments';
import { notifications } from './notifications';
import { onboarding } from './onboarding';
import { personalLoans } from './personalLoans';
import { pro } from './pro';
import { projections } from './projections';
import { receipts } from './receipts';
import { reminders } from './reminders';
import { reports } from './reports';
import { reservas } from './reservas';
import { settings } from './settings';
import { subscriptions } from './subscriptions';
import { tags } from './tags';
import { transactions } from './transactions';
import { ui } from './ui';
import { validation } from './validation';
import { widgets } from './widgets';

/**
 * Parcial por design (ADR 0044): chave ausente cai no pt-BR via fallback do
 * i18next — nunca vira tag crua na tela. As lacunas são listadas pelo
 * locales/__tests__/check-i18n.test.ts a cada `npm test`.
 */
export const en: DeepPartialStrings<TranslationSchema> = {
    accounts,
    ai,
    budget,
    categories,
    common,
    creditCards,
    financings,
    goals,
    home,
    installments,
    notifications,
    onboarding,
    personalLoans,
    pro,
    projections,
    receipts,
    reminders,
    reports,
    reservas,
    settings,
    subscriptions,
    tags,
    transactions,
    ui,
    validation,
    widgets,
};
